import React from "react";
import { DisponibiliteEtendu, intToDisponibiliteEtendu } from "../../../../models/interfaces/IDisponibiliteEtendu";

//Disponiblite étendu
interface IProps {
  Item?: number;
  tableau?:boolean;
}
const HtmlRenderDisponibiliteEtendu: React.FC<IProps> = ({ Item,tableau }) => {
  let color = "black";
const disponibilite = intToDisponibiliteEtendu(Item);

switch (disponibilite) {
  case DisponibiliteEtendu.Disponible: {
    color = "green";
    break;
  }
  case DisponibiliteEtendu.AParaitre: {
    color = "blue";
    break;
  }
  case DisponibiliteEtendu.Reimpressionencours:
  case DisponibiliteEtendu.Manqueprovisoirement: {
    color = "yellow";
    break;
  }
  case DisponibiliteEtendu.ArretCommercialisation:
  case DisponibiliteEtendu.Epuise:
  case DisponibiliteEtendu.PlusDistribue:
  case DisponibiliteEtendu.ManqueprovisoirementRouge: {
    color = "red";
    break;
  }
  default: {
    color = "black"; // Optionnel : valeur par défaut
  }
}


  return (
    <span className={`pae-dispo${tableau ? "-tableau" : ""} ${color}`}>
      {!tableau && (
          <>
            {" "}
            {disponibilite ? disponibilite.valueOf() : "Non défini"}
          </>
      )}
      
    </span>
  );
};

export default HtmlRenderDisponibiliteEtendu;
